import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { themeTokensCss } from '@hew3/shared';
import './styles/base.css';
import './styles/components.css';
import App from './App.tsx';

/**
 * 设计令牌注入：颜色、圆角、字体族只有一处定义（@hew3/shared/src/theme.ts），
 * 由这里写入 :root，CSS 组件层与图表引擎都从这里取值。
 * 这正是原型做不到的 —— 它的数据层里散落着 var(--h) 与 #9B8CFF 这类字面量。
 */
const tokenStyle = document.createElement('style');
tokenStyle.id = 'hew3-design-tokens';
tokenStyle.textContent = themeTokensCss();
document.head.prepend(tokenStyle);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 成员数据变动不频繁，1 分钟内不重复请求；切回页面时可接受短暂陈旧
      staleTime: 60_000,
      retry: (failureCount, error) => {
        // 401 / 403 重试没有意义
        const status = (error as { status?: number }).status;
        if (status === 401 || status === 403 || status === 404) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('未找到 #root 挂载点');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
